import { RootState } from '../../rootReducer';

export const applicationSelectors = {
  getApplcationState: (state: RootState) => state.ApplicationState,
  getUserPrefs: (state: RootState) => state.ApplicationState.userPrefs,
  getImmersiveToken: (state: RootState) =>
    state.ApplicationState.immersiveToken,
  getAppConfig: (state: RootState) => state.ApplicationState.config,
};
